module.exports = __webpack_public_path__ + "static/img/finger.d74ce673.webp";